// i18n area 'backups' — locale hr-HR (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/backups.hr-HR.meta.json.
import type { enUS } from './backups'

export const hrHR: typeof enUS = {
  ckpt: {
    contents: 'Prima',
    contentsHint:
      'Što ovdje smije sletjeti. „Checkpointi“ je konfiguracija klastera, „Sigurnosne kopije podataka“ su kopije VM-ova: dva čitanja se sastavljaju, jedno odredište može primiti oboje.',
    content: { checkpoints: 'Checkpointi', backups: 'Sigurnosne kopije podataka' },
    destinationsTitle: 'Odredišta backupa',
    checkpointsTitle: 'Checkpointi',
    restoreTitle: 'Vraćanje',
    addDestination: 'Dodaj odredište',
    addDestinationTitle: 'Dodaj odredište backupa',
    editDestinationTitle: 'Uredi odredište',
    storage: 'Storage',
    storageHint: 'Dir-like storage (dir/NFS/CIFS/CephFS) — artefakti su obične datoteke unutar namespacea platforme.',
    schedule: 'Raspored',
    scheduleNone: 'Samo ručno',
    scheduleHourly: 'Svaki sat',
    scheduleDaily: 'Dnevno',
    scheduleWeekly: 'Tjedno',
    scheduleHour: 'Sat',
    scheduleWeekday: 'Dan',
    scheduleHint:
      'Planirani checkpointi nemaju operatera koji bi upisao masterpass: tajne iz keystorea pakiraju se kao placeholderi.',
    retention: 'Zadržavanje',
    retentionHint:
      'Koliko planiranih checkpointa zadržati — sweeper uklanja najstarije iznad tog broja. Ručni checkpointi i checkpointi prije vraćanja nikad se ne uklanjaju.',
    paused: 'Pauzirano',
    pausedHint:
      'Operaterov blackout: dok pauza traje, na ovom se odredištu ništa ne planira i ništa ne obrezuje — podatkovne policy i checkpointi podjednako. Izvršavanja u tijeku nikad se ne diraju.',
    orphanRuns: '{n} osirotjelih izvršavanja',
    orphanRunsHint:
      'Planirana izvršavanja policyja koji više ne postoje na ovom odredištu: nikakva ih retencija ne upravlja — nikad brojena, nikad orezivana — i briše ih samo ruka. Leća „backups” u tvirt diagnose imenuje uklonjene policyje.',
    rescan: 'Ponovno usvoji artefakte',
    rescanTitle: 'Ponovno usvajanje artefakata za {name}',
    rescanHint:
      'Ponovno gradi katalog sigurnosnih kopija (VM/CT/App) iz manifesta artefakata na odredištu. Postojeći retci nikad se ne diraju; kopije nepoznatih politika ostaju siročad (nikad se automatski ne obrezuju). Potez nakon bootstrap obnove.',
    masterpassDrWarning:
      'Scenarij katastrofe: LUKS diskovi vraćaju se SAMO iz checkpointa S masterpassom. Planirani checkpointi pakiraju rezervirana mjesta — povremeno napravite ručni checkpoint s masterpassom.',
    policy: {
      title: 'Policy sigurnosnih kopija podataka',
      hint: 'Imenovane policy: koji objekti (kind, tagovi, scopeovi), koliko često, kada izvršavanje smije krenuti i koliko kopija zadržati. Gesta upisa ostaje vlasniku objekta: tagovi se dodjeljuju na njegovu vlastitom scopeu.',
      add: 'Dodaj policy',
      column: 'Policy podataka',
      name: 'Naziv',
      nameHint:
        'Oznaka policyja, jedinstvena unutar odredišta. Izvršavanja slijede stabilni id policyja: preimenovanje je besplatno; brisanje čini njegova izvršavanja siročadi (više se ne broje ni ne orezuju).',
      kindLocked: 'Obitelj objekata postojećeg policyja ne može se promijeniti: stvorite novi policy.',
      kindLabel: 'Objekti',
      kind: { vm: 'Virtualni strojevi', ct: 'Kontejneri', app: 'Aplikacije' },
      tags: 'Selektor tagova',
      tagsHint:
        'Parovi tag=vrijednost odvojeni zarezima, u AND-u. Prazni tagovi i scopeovi ne odabiru ništa — nikad „sve“.',
      scopes: 'Scopeovi',
      scopesHint: 'Putanje scopeova (podstabla), odvojene zarezima, međusobno u OR-u.',
      windowStart: 'Prozor od',
      windowEnd: 'Prozor do',
      windowHint:
        'Prozor izvršavanja (HH:MM, lokalno vrijeme; početak iza kraja preskače ponoć). Upravlja samo POČETKOM: izvršavanje koje ga prekorači nikad se ne ubija.',
      mode: 'Način',
      modeHint: 'Inkrementalni jaše na obitelji serija; prekinuta serija degradira u full, rečeno u dnevniku.',
      modeFull: 'Full',
      modeIncremental: 'Inkrementalni',
      requireQuiesce: 'Zahtijevaj quiesce (guest agent)',
      paused: 'Policy pauzirana',
      retentionNone: 'Zadrži sve',
      retentionCount: 'Broj',
      retentionGfs: 'GFS prstenovi',
      gfs: { keepLast: 'Posljednje', daily: 'Dnevne', weekly: 'Tjedne', monthly: 'Mjesečne', yearly: 'Godišnje' },
      gfsHint:
        'Za svaki prsten zadržava se najnovija kopija iz svakoga od posljednjih N razdoblja. Zadržana kopija drži na životu cijeli svoj lanac — nikad baza sa siročadi.',
      lastRun: 'Posljednje izvršavanje',
      neverRan: 'nikad izvršeno'
    },
    lastCheckpoint: 'Posljednji checkpoint',
    neverRun: 'Nikad stvoreno',
    createNow: 'Stvori checkpoint',
    createNowTitle: 'Stvori checkpoint — {name}',
    masterpass: 'Masterpass',
    masterpassHint:
      'Štiti tajne vrijednosti keystorea (argon2id → AES-256-GCM, po vrijednosti). Nikad se ne sprema: čuvajte ga — bez njega vraćanje daje placeholdere umjesto pravih tajni.',
    masterpassEmptyHint: 'Ostavite prazno da se umjesto tajni zapakiraju eksplicitni placeholderi.',
    createStarted: 'Checkpoint u tijeku…',
    destinationInUseError: "'{name}' još sadrži checkpointe — najprije ih izbrišite.",
    origin: 'Podrijetlo',
    originManual: 'ručno',
    originSchedule: 'planirano',
    originPreRestore: 'prije vraćanja',
    originPreChange: 'prije izmjene',
    preChangeRetention: 'Checkpointi prije izmjene',
    preChangeRetentionHint:
      'Prazno = isključeno. Prvi zapis konfiguracije nakon razdoblja mirovanja ovdje zamrzava prethodno stanje (podrijetlo „prije izmjene“); najnoviji se čuvaju do broja — vlastita retencija, podložna rezanju.',
    diffTitle: 'Pregled izmjena',
    diffFailed: 'Pregled nije uspio',
    diffRetry: 'Pokušaj ponovno',
    diffCounts: '{changed} za izmjenu · {missing} za stvaranje · {extra} viška · {equal} identično',
    diffChanged: 'mijenja se',
    diffMissing: 'bio bi stvoren',
    diffExtra: 'bio bi obrisan',
    diffJsonb: 'jsonb reference nije moguće provjeriti prije primjene',
    diffSecret: 'zapečaćena polja, neusporediva',
    diffMore: 'još {n}…',
    diffNeeded: 'Pokretanje se aktivira kad pregled odražava odabir.',
    phase: 'Stanje',
    phaseRunning: 'u tijeku',
    phaseComplete: 'dovršeno',
    phaseError: 'pogreška',
    secrets: 'Tajne',
    secretsMasterpass: 'masterpass',
    secretsPlaceholders: 'placeholderi',
    size: 'Veličina',
    created: 'Stvoreno',
    destination: 'Odredište',
    download: 'Preuzmi .tvbk',
    deleteCheckpoint: 'Izbriši checkpoint',
    noCheckpoints: 'Nema checkpointa — stvorite jedan iz odredišta.',
    families: 'Obitelji',
    generation: 'Generacija',
    completedAt: 'Dovršeno',
    errorDetail: 'Detalj pogreške',
    manifest: 'Manifest',
    restoreHint: 'Prenesite artefakt .tvbk: preglednik prikazuje što sadrži, a zatim birate što vratiti i kako.',
    uploadFile: 'Prenesi datoteku .tvbk',
    uploading: 'Prijenos u tijeku…',
    uploadFailed: 'Artefakt nije moguće otvoriti',
    explorerTitle: 'Sadržaj checkpointa',
    checkpointFrom: 'Checkpoint klastera {cluster}, stvoren {when} ({origin}, generacija {generation})',
    otherCluster:
      'Ovaj checkpoint potječe s DRUGOG klastera ({cluster}) — vraćanje između klastera dolazi u budućem roundu.',
    encrypted: 'šifrirano',
    objectsCount: 'objekata: {n}',
    mode: 'Način',
    modeMerge: 'Merge — usklađuje: upsert odabranih redaka, ništa se ne briše',
    modeOverwrite:
      'Overwrite — checkpoint pobjeđuje: u cijelosti odabrana obitelj zamjenjuje se u potpunosti (trenutačni retci kojih nema u checkpointu uklanjaju se)',
    restoreMasterpassHint:
      'Masterpass kojim je checkpoint stvoren. Bez njega se šifrirane tajne vraćaju kao eksplicitni placeholderi.',
    checkMasterpass: 'Provjeri',
    masterpassOk: 'Masterpass je ispravan',
    masterpassWrong: 'Pogrešan masterpass',
    parachuteDestination: 'Padobransko odredište',
    parachuteHint: 'Prije nego što takne ijedan redak, zadatak ovdje stvara automatski checkpoint prije vraćanja.',
    summaryTitle: 'Što će se dogoditi',
    summaryLine: '{family}: {what} — {mode}',
    summaryWhole: 'cijela obitelj',
    summaryObjects: 'odabranih objekata: {n}',
    confirmHint: 'Upišite naziv klastera ({name}) za potvrdu — vraćanje prepisuje deklariranu konfiguraciju.',
    confirmField: 'Naziv klastera',
    startRestore: 'Vrati',
    restoreRunning: 'Vraćanje u tijeku…',
    restoreDone: 'Vraćanje dovršeno — reconcileri konvergiraju na novu deklaraciju.',
    restoreFailed: 'Vraćanje nije uspjelo',
    discard: 'Odbaci',
    selectionEmpty: 'Odaberite barem jednu obitelj ili objekt.'
  },

  backup: {
    intro: {
      title: 'Sigurnosne kopije podataka VM-ova i kontejnera',
      subtitle: 'Gradivni blokovi kojima se služi vanjski softver za sigurnosne kopije',
      whatItIs:
        'TVirt izlaže četiri primitive: quiesced snimke, praćenje promjena po disku, NBD izvoz samo za čitanje i izvoz konfiguracije. Njima upravljaju Veeam, Bacula, Acronis i društvo.',
      whatItIsNot:
        'TVirt nije proizvod za sigurnosne kopije: ništa ne planira, ne provodi zadržavanje i ne čuva nikakvu arhivu vaših podataka. Zadržavanje, katalozi i politike vraćanja ostaju na softveru koji već koristite.'
    },
    cbt: {
      title: 'Praćenje promjena',
      colVm: 'VM',
      colDisk: 'Disk',
      colState: 'Stanje',
      colBitmaps: 'Bitmape',
      colObservedAt: 'Zabilježeno',
      colChangeId: 'Change ID',
      colMechanic: 'Mehanizam',
      stateActive: 'Aktivno',
      stateInactive: 'Isključeno',
      stateInconsistent: 'Nedosljedno — sljedeća sigurnosna kopija mora biti puna',
      stateBroken: 'Lanac prekinut — isključite, pa uključite kao novi lanac',
      stateSnapshots: 'Uvijek uključeno — delta između snimaka',
      stateUnavailable: 'Nedostupno na ovom disku',
      mechanic: {
        'qcow2-bitmap': 'qcow2 bitmapa',
        'rbd-snapdiff': 'Diff Ceph snimaka',
        'lvm-thin-delta': 'Delta thin poola',
        none: 'Nema'
      },
      empty:
        'Nema VM diska. Praćenje promjena čita se po disku: uključite ga na qcow2 disku ili radite snimke na rbd/SAN.',
      chainBroken: 'Lanac prekinut',
      chainBrokenText:
        'Prekinut događajem {reason}: {bitmaps}. Isključite bitmapu (lanac je izgubljen, sljedeća kopija je puna), pa je uključite kao novi lanac.',
      lineages: 'Epohe',
      epochFrozen: 'zamrznuta u snimci {snapshot}',
      epochLost: 'izgubljena ({cause})',
      epochRecording: 'bilježi na glavi',
      milestones: 'Prekretnice (snimke)',
      enable: 'Uključi praćenje promjena',
      disable: 'Isključi',
      reset: 'Resetiraj',
      changedAreas: 'Promijenjena područja',
      denied: 'Nemate dozvolu na ovoj VM',
      enableTitle: 'Uključi praćenje promjena',
      disableTitle: 'Isključi praćenje promjena',
      resetTitle: 'Resetiraj bitmapu',
      areasTitle: 'Promijenjena područja',
      bitmapName: 'Naziv bitmape',
      bitmapNameHint: 'Vlastiti naziv: tvirt- i tvbk- pripadaju platformi',
      granularity: 'Granularnost (bajtovi)',
      granularityHint: 'Potencija broja dva; zadano 65536',
      bitmap: 'Bitmapa',
      disableHint: 'Uklanja bitmapu i cijelu povijest njezinih epoha: sljedeća kopija mora biti puna.',
      resetHint: 'Prazni bitmapu — nova osnova: change ID stariji od reseta više se ne može složiti.',
      areasFrom: 'Od snimke',
      areasTo: 'Do snimke',
      areasRun: 'Izračunaj',
      areasResult: '{count} promijenjenih područja, {bytes}',
      areasEmpty: 'Nema promijenjenih područja između dviju snimaka',
      areasZero: 'nule',
      areasMore: 'prikazano prvih {shown} od {count}',
      submit: 'Potvrdi',
      error: 'Radnja praćenja promjena nije uspjela'
    },
    exports: {
      title: 'Otvoreni NBD exporti',
      colVm: 'VM',
      colDisk: 'Disk',
      colSnapshot: 'Snimka',
      colBitmap: 'Bitmapa',
      colPhase: 'Faza',
      colNode: 'Čvor',
      colEndpoint: 'Endpoint',
      colExpires: 'Istječe',
      colCreated: 'Otvoreno',
      colError: 'Greška',
      phase: {
        preparing: 'Priprema',
        ready: 'Spreman',
        closed: 'Zatvoren',
        error: 'Neuspio'
      },
      expiresIn: 'za {minutes} min',
      expired: 'istekao',
      empty: 'Nema exporta. Sesija čitanja poslužuje jedan disk na jednom snapshotu NBD klijentu; sesija pisanja puni netaknuti disk zaustavljenog VM-a. Obje umiru po isteku.',
      endpointHint: 'TLS s CA klastera; naziv exporta je ulaznica — umire sa sesijom',
      closeDenied: 'Nemate dozvolu zatvarati exporte ove VM',
      open: 'Otvori NBD export',
      openTitle: 'Otvori NBD export',
      openDisk: 'Disk',
      openBitmap: 'Bitmapa (neobavezno)',
      openBitmapHint:
        'Objavljuje epohu te bitmape zamrznutu u ovoj snimci kao meta-context promijenjenih ekstenata (samo qcow2 diskovi)',
      openTtl: 'Trajanje (minute)',
      openSubmit: 'Otvori',
      openError: 'Export nije bilo moguće otvoriti',
      colMode: 'Način',
      mode: {
        read: 'Čitanje',
        write: 'Pisanje'
      },
      caCertificate: 'CA klastera',
      caCopy: 'Kopiraj PEM',
      caDownload: 'Preuzmi ca-cert.pem',
      caHint: 'Zapišite PEM u ca-cert.pem u privatnoj mapi i spojite se s nbds://…?tls-certificates=<mapa> (nbdcopy, nbdinfo) ili --object tls-creds-x509,dir=<mapa>,endpoint=client (qemu-img)',
      caAbsent: 'Sesija ne nosi CA (nema PKI-ja)',
      openWrite: 'Otvori export za pisanje',
      openWriteTitle: 'Otvori export za pisanje',
      openWriteIntro: 'Disk mora biti netaknut: rođen prazan, nikad pisan, bez snapshota; VM zaustavljen. Vraćanje PUNI disk, ne popravlja ga. Dok je sesija otvorena, VM se ne pokreće, ne radi snapshot, ne klonira se, a disk se ne premješta.',
      openWriteSubmit: 'Otvori',
      openWriteError: 'Export za pisanje nije bilo moguće otvoriti',
      openWriteDenied: 'Nedostaje vam vm.restore.data na ovom VM-u',
      openWriteStopped: 'Zaustavite VM da biste otvorili export za pisanje',
      fromDescription: 'Stvori VM iz opisa',
      fromDescriptionTitle: 'Stvori VM iz opisa',
      fromDescriptionIntro: 'Opis iz export-vm-meta vraća se kao zaustavljeni VM s praznim diskovima opisane geometrije — spreman za exporte za pisanje, disk po disk. Bajtovi ne prolaze ovuda: nosi ih restore-disk (CLI) ili NBD klijent proizvoda za sigurnosne kopije.',
      fromDescriptionDoc: 'Opis (JSON)',
      fromDescriptionDocHint: 'Zalijepite dokument iz export-vm-meta ili odaberite datoteku',
      fromDescriptionFile: 'Odaberi datoteku…',
      fromDescriptionInvalid: 'Tekst nije JSON dokument',
      fromDescriptionName: 'Ime novog VM-a',
      fromDescriptionScope: 'Scope',
      fromDescriptionScopeHome: 'Vaš početni scope',
      fromDescriptionStorage: 'Pohrana diskova',
      fromDescriptionStorageHint: 'Svaki disk rađa se ovdje, u zadanom formatu pohrane',
      fromDescriptionMetadataStorage: 'Pohrana metapodataka',
      fromDescriptionSameAsStorage: 'Ista kao za diskove',
      fromDescriptionBridge: 'Bridge',
      fromDescriptionBridgeHint: 'Bez bridgea ni mreže VM se rađa bez kartica',
      fromDescriptionNetwork: 'Logička mreža (fabric/mreža)',
      fromDescriptionSubmit: 'Stvori',
      fromDescriptionError: 'VM nije bilo moguće stvoriti',
      fromDescriptionDone: 'VM stvoren: {name}',
      fromDescriptionOpen: 'Otvori VM',
      fromDescriptionDenied: 'Nedostaje vam vm.create',
      fromDescriptionStillRunning: 'Stvaranje još traje: čeka se dalje'
    },

    // Il MOTORE integrato (#28) — i backup dei dati che TVirt fa davvero.
    vm: {
      title: 'Sigurnosne kopije podataka VM-ova',
      titleOnVm: 'Sigurnosne kopije podataka',
      empty:
        'Nema kopije. Kopija prenosi diskove, varstore UEFI i stanje vTPM na odredište i nadživljava virtualni stroj.',
      colVm: 'VM',
      colCreated: 'Izrađena',
      colPhase: 'Ishod',
      colDestination: 'Odredište',
      colContains: 'Sadržaj',
      colSize: 'Veličina',
      colOrigin: 'Podrijetlo',
      colMode: 'Vrsta',
      retentionChip: 'Zadržavanje',
      retentionHint:
        'Zadržavanje odredišta može obrisati ovu kopiju bez pitanja: rođena je iz rasporeda. Ručne kopije nikad se ne pometu.',
      policyRemoved: 'Policy uklonjen: {name}',
      policyRemovedHint:
        'Policy koji je planirao ovaj backup više ne postoji: nikakva ga retencija ne upravlja (nikad se ne orezuje automatski) — obrišite ga ručno kad više ne treba.',
      phase: {
        running: 'U tijeku',
        complete: 'Dovršena',
        error: 'Neuspjela'
      },
      origin: {
        manual: 'Ručna',
        schedule: 'Zakazana'
      },
      mode: {
        full: 'Puna',
        incremental: 'Inkrementalna'
      },
      contains: {
        disks: 'Diskovi',
        varstore: 'Varstore UEFI',
        vtpm: 'Stanje vTPM',
        snapshots: 'Snimke'
      },
      vmState: {
        stopped: 'VM ugašen',
        running: 'VM radi (toplo)'
      },
      artifactClass: { metadata: 'Metapodaci', data: 'Podaci', secret: 'Tajna' },
      detail: {
        tabOverview: 'Pregled',
        tabArtefact: 'Artefakt',
        id: 'Identifikator',
        scope: 'Opseg',
        vmState: 'Stanje VM-a pri kopiranju',
        pointInTime: 'Trenutak podataka',
        completedAt: 'Dovršena',
        node: 'Čvor koji je kopirao',
        error: 'Pogreška',
        path: 'Mapa na pohrani',
        checksum: 'sha256 manifesta',
        secretsExposed: 'Osjetljiv materijal u otvorenom obliku',
        secretsExposedYes: 'Da — odredište ne šifrira',
        secretsExposedNo: 'Ne',
        baseBackup: 'Osnovna kopija',
        tabManifest: 'Manifest',
        manifestHint:
          'Otvoreni indeks artefakta: jedna datoteka po retku sa svojim sha256. Mapa se provjerava i bez TVirta — dovoljni su qemu-img, tar i jq.',
        manifestEmpty: 'Manifest ne navodi datoteke.',
        manifestError: 'Manifest se ne može pročitati',
        colEntry: 'Datoteka',
        colClass: 'Klasa',
        colSha: 'sha256'
      },
      create: {
        action: 'Kopiraj sada',
        title: 'Kopiraj sada',
        submit: 'Pokreni kopiju',
        destination: 'Odredište',
        destinationHint: 'Samo odredišta koja primaju kopije.',
        noDestinations: 'Nijedno odredište ne prima kopije: stvorite ga u Sustav → Checkpointi.',
        contentsHint:
          'Putuju svi diskovi, varstore UEFI i stanje vTPM. Posljednja dva su bit: zapečaćen gost mora se ponovno podići.',
        error: 'Kopija nije krenula',
        stillRunning: 'Kopija još traje — kopiranje se nastavlja i ako zatvorite.',
        vmRunning:
          'Stroj je {phase}: sigurnosna kopija traži stabilan VM — ugašen za hladno kopiranje, pokrenut za toplo.'
      },
      restore: {
        action: 'Vrati',
        title: 'Vrati',
        intro: 'Vraćanje je nepovratno. Odaberite kamo se podaci vraćaju: u novi stroj ili preko izvornoga.',
        modeNewVm: 'Vrati u NOVI VM',
        modeNewVmHint:
          'Ne dira ništa što postoji — time se kopija provjerava. Novi identifikator i svježe iskovane MAC adrese.',
        modeOver: 'Prepiši izvorni VM',
        modeOverHint: 'Uništava trenutne podatke ciljnog VM-a, bez povratka. Stroj mora biti ugašen.',
        newName: 'Ime novog VM-a',
        newNameHint: 'Mora biti slobodno u ciljnom opsegu.',
        storage: 'Pohrana za diskove',
        storageHint: 'Obvezno: manifest bilježi veličinu i format diska, nikad pohranu na kojoj je ležao.',
        metadataStorage: 'Pohrana za varstore i vTPM',
        metadataStorageHint: 'Gdje slijeću UEFI identitet i stanje vTPM.',
        sameAsStorage: 'Ista kao diskovi',
        bridge: 'Bridge domaćina',
        bridgeHint:
          'Svaka zabilježena mrežna kartica vraća se na ovaj bridge s novom MAC adresom. Ostavljeno prazno, VM se rađa bez kartica — sigurnija zadana vrijednost.',
        overwriteTitle: 'Upravo ćete prepisati ovaj VM',
        overwriteName: 'Ime',
        overwriteId: 'Identifikator',
        overwriteDisks: 'Diskovi koji će biti prepisani',
        overwriteNoDisks: 'Nema diskova.',
        overwriteKeeps:
          'Netaknuti ostaju identifikator, ime, opseg, mrežne kartice i MAC adrese: kopija su PODACI, konfiguracija je checkpoint.',
        confirmField: 'Ime VM-a',
        confirmHint: 'Upišite {name} za potvrdu.',
        targetLoading: 'Čitanje ciljnog VM-a…',
        targetRunning: 'Ciljni VM je {phase}: vraćanje prepisuje bajtove ispod gosta, pa ga traži ugašenog.',
        targetGone: 'Izvorni VM više se ne može pročitati: ostaje vraćanje u novi VM.',
        onlyComplete: 'Kopija je {phase}: vratiti može samo dovršena kopija.',
        submitNewVm: 'Vrati u novi VM',
        submitOver: 'Prepiši',
        error: 'Vraćanje nije krenulo',
        stillRunning: 'Vraćanje još traje — kopiranje cijelih diskova traži vrijeme.'
      }
    },
    guest: {
      title: {
        ct: 'Sigurnosne kopije podataka kontejnera',
        app: 'Sigurnosne kopije podataka App-ova'
      },
      tabTitle: 'Sigurnosne kopije',
      empty: 'Nema sigurnosnih kopija. Kopija prenosi trajne podatke na odredište i nadživljava svoj objekt.',
      colSubject: {
        ct: 'Kontejner',
        app: 'App'
      },
      colCreated: 'Izrađena',
      colPhase: 'Ishod',
      colDestination: 'Odredište',
      colContains: 'Sadržaj',
      colSize: 'Veličina',
      colOrigin: 'Podrijetlo',
      policyRemoved: 'Policy uklonjen: {name}',
      policyRemovedHint:
        'Policy koji je planirao ovaj backup više ne postoji: nikakva ga retencija ne upravlja (nikad se ne orezuje automatski) — obrišite ga ručno kad više ne treba.',
      phase: {
        running: 'U tijeku',
        complete: 'Dovršena',
        error: 'Neuspjela'
      },
      origin: {
        manual: 'Ručna',
        schedule: 'Planirana'
      },
      state: {
        stopped: 'Objekt zaustavljen',
        running: 'Objekt radi (zamrznut)'
      },
      contains: {
        rootfs: 'Stablo rootfs',
        config: 'Konfiguracija',
        volumes: 'Trajni volumeni',
        root: 'Trajni root'
      },
      artifactClass: {
        metadata: 'Metapodaci',
        data: 'Podaci',
        secret: 'Tajna'
      },
      create: {
        action: 'Izradi kopiju sada',
        title: 'Nova sigurnosna kopija',
        submit: 'Pokreni kopiju',
        error: 'Kopija nije krenula',
        destination: 'Odredište',
        destinationHint: 'Samo odredišta koja prihvaćaju sigurnosne kopije podataka.',
        noDestinations:
          'Nijedno odredište ne prihvaća sigurnosne kopije podataka: dodajte odredištu „Sigurnosne kopije podataka“.',
        hint: {
          ct: 'Putuje cijelo stablo rootfs, vjerno (numerički vlasnici, xattrs, ACL-ovi), plus deklarirana konfiguracija u manifestu. Kontejner koji radi ZAMRZAVA se za cijelo pakiranje: crash-consistent kopija, deklarirana.',
          app: 'Putuju SAMO trajni volumeni (i trajni root), plus konfiguracija u manifestu. Efemerno je isključeno ratifikacijom i manifest ga imenuje; env vrijednosti deklarirane tajnima ne putuju.'
        },
        stillRunning: 'Kopija još traje — pakiranje cijelih stabala traje.'
      },
      detail: {
        tabOverview: 'Pregled',
        tabManifest: 'Manifest',
        id: 'Identifikator',
        scope: 'Opseg',
        state: 'Stanje pri kopiji',
        pointInTime: 'Podaci u trenutku',
        completedAt: 'Zaključena',
        node: 'Čvor koji je kopirao',
        error: 'Greška',
        path: 'Mapa na pohrani',
        checksum: 'sha256 manifesta',
        manifestHint:
          'Indeks artefakta: jedan zapis po datoteci s njezinim sha256 — bez hasheva je „kopija postoji“ čin vjere.',
        manifestError: 'Manifest se ne može pročitati',
        manifestEmpty: 'Nema artefakata u manifestu.',
        colEntry: 'Datoteka',
        colClass: 'Klasa',
        colSha: 'sha256',
        excluded: 'Isključeno ratifikacijom (ne putuje)',
        secretKeys: 'Izostavljeni tajni env ključevi (#307) — ponovno ih unesite nakon vraćanja'
      },
      restore: {
        action: 'Vrati',
        title: 'Vraćanje',
        submit: 'Vrati',
        error: 'Vraćanje nije krenulo',
        stillRunning: 'Vraćanje još traje — raspakiravanje cijelih stabala traje.',
        onlyComplete: 'Kopija je {phase}: vratiti može samo dovršena kopija.',
        asNew: {
          ct: 'U NOVI kontejner — ništa ne uništava: gesta kojom se kopija provjerava',
          app: 'U NOVI App — ništa ne uništava: gesta kojom se kopija provjerava'
        },
        over: {
          ct: 'PREKO izvornog kontejnera — cijelo stablo rootfs se zamjenjuje',
          app: 'PREKO izvornog App-a — sadržaj svakog trajnog volumena se zamjenjuje'
        },
        name: 'Naziv novog objekta',
        storage: 'Pohrana',
        storageHint: 'Gdje vraćeni podaci slijeću — manifest nikad ne bilježi izgubljeni pool.',
        storageDeclared: 'Pohrane deklarirane u manifestu',
        bridge: 'Bridge domaćina',
        bridgeHint:
          'Svaka zabilježena kartica vraća se na ovaj bridge sa svježim MAC-om. Prazno = rađa se nespojen, najsigurnija zadana vrijednost.',
        node: 'Čvor',
        nodeHint: 'Član na kojem se App ponovno rađa: čvor je identitet klastera i nikad ne dolazi iz manifesta.',
        secretKeysWarning:
          'Env vrijednosti deklarirane tajnima ne putuju u kopiji: ponovno rođena kopija ih želi unesene (log zadatka imenuje ključeve).',
        overInventory: 'Upravo ćete prepisati ovaj objekt',
        confirmType: 'Upišite {name} za potvrdu',
        targetGone: 'Izvorni objekt više se ne može pročitati: ostaje vraćanje kao novo.',
        targetLoading: 'Čitanje ciljnog objekta…',
        targetRunning: 'Ciljni objekt radi: vraćanje zamjenjuje bajtove pod gostom pa ga želi zaustavljenog.'
      }
    }
  }
}
